import React from 'react';
import * as webpageStyles from "./webpageStyles.jsx"
import * as webpageTools from "./webpageTools.jsx"

import * as visualAssets from './../visualAssets.jsx';

const appStoreStyle = {
   display:"block",
   overflow:"hidden",
   background:visualAssets.appStoreIconUrl,
   backgroundRepeat: "no-repeat",
   width:"20vw",
   height:"6vw",
   maxWidth:200,
   maxHeight:60,
   backgroundSize:"contain",
   margin:"auto",
}

const googlePlayStyle = {
   display:"block",
   width:"23vw",
   //height:"7vw",
   maxWidth:230,
   margin:"auto",
   backgroundSize:"contain",
   backgroundRepeat: "no-repeat"
}

export class Information extends React.Component {
   
   constructor(props)
   {
      super(props);

   }


   setTextLeft(text)
   {
      this.infotextLeft = text;
      this.forceUpdate();
   }

   setTextRight(text)
   {
      this.infotextRight = text;
      this.forceUpdate();
   }

   componentWillMount()
   {
      this.infotextLeft = "";
      this.infotextRight = "";


      webpageTools.getTextFileAsString("informationLeft.txt", this.setTextLeft.bind(this));
      webpageTools.getTextFileAsString("informationRight.txt", this.setTextRight.bind(this));
   }
	
   render() {
    

      return (
         <div style={webpageStyles.outerContainer}>
            <div style={webpageStyles.leftColumnContainer}>
               <div dangerouslySetInnerHTML={{__html: this.infotextLeft}} className={"textColumn"}/>
            </div>
            <div style={webpageStyles.rightColumnOuterContainer}>
               <img src={visualAssets.soundmapLogo} style={webpageStyles.soundmapLogo}/>
               <img src={visualAssets.logoDKF} style={webpageStyles.dkfLogo} />
               <div dangerouslySetInnerHTML={{__html: this.infotextRight}}  className={"rightColumn"}/>
               <div style={{height:60}}/>
               <a href={"https://itunes.apple.com/us/app/soundmap/id1218727645?ls=1&mt=8"} style={appStoreStyle}> </a>
               
               <div style={{display:"block", height:30}}/>
               <a href='https://play.google.com/store/apps/details?id=dk.soundmap.app&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                  <img style={googlePlayStyle} alt='Nu på Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/da_badge_web_generic.png'/>
               </a>
               <div style={{display:"block", height:30}}/>
               {/*<div className={"elemComment"}>
                  <a>Ikonforklaring til App</a>
                  <br/>
                  <a style={{color:"#646463"}} href="Assets/Icon_list_soundmap.pdf" download>(Download pdf)</a>
               </div>*/}
               <div className={"elemComment"}>
                  <a>Guide til brugere</a>
                  <br/>
                  <a style={{color:"#646463"}} href="https://docs.google.com/document/d/1Vx_oj179wOMFFe6t9oPFPvwT0_i6a_fRa0hBJVr1CAQ/export?format=pdf" download>(Download pdf)</a>
               </div>
            </div>
         </div>
         
         );
   }
}


// WEBPACK FOOTER //
// ./js/webpages/information.jsx